export const CONTRACTS_LOAD_REQUEST = 'CONTRACTS_LOAD_REQUEST';
export const CONTRACTS_LOAD_SUCCESS = 'CONTRACTS_LOAD_SUCCESS';
export const CONTRACTS_LOAD_FAILURE = 'CONTRACTS_LOAD_FAILURE';
export const CONTRACTS_ADD_CONTRACT = 'CONTRACTS_ADD_CONTRACT';
export const CONTRACTS_REMOVE_CONTRACT = 'CONTRACTS_REMOVE_CONTRACT';
export const CONTRACTS_REMOVE_CANDIDATE_PARTY = 'CONTRACTS_REMOVE_CANDIDATE_PARTY';
export const CONTRACTS_ADD_CANDIDATE_PARTY = 'CONTRACTS_ADD_CANDIDATE_PARTY';
